// 轻量 fetch 封装，避免新引入依赖

export interface ApiError {
  code: number
  message: string
  requestId?: string
  details?: any
}

const BASE_URL = '/api'

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE_URL}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers || {}),
    },
    credentials: 'include',
    ...init,
  })

  const text = await res.text()
  let data: any
  try { data = text ? JSON.parse(text) : null } catch { data = text }

  if (!res.ok) {
    // 明确错误返回，严禁模拟/降级
    const err: ApiError = data?.code ? data : { code: res.status, message: res.statusText }
    throw err
  }

  return data as T
}

export const api = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, body?: any) => request<T>(path, body ? { method: 'POST', body: JSON.stringify(body) } : { method: 'POST' }),
  put: <T>(path: string, body?: any) => request<T>(path, body ? { method: 'PUT', body: JSON.stringify(body) } : { method: 'PUT' }),
  del: <T>(path: string) => request<T>(path, { method: 'DELETE' }),
}

export default api

